import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api";
import { Status } from "../../common/constants";
import { signInUrl } from "../../config";
import { IInitialSliceState } from "../../common/types/commonTypes";

const SIGN_IN_USER: string = "signInUser";

const initialState: IInitialSliceState = {
  msg: null,
  status: Status.IDLE,
  error: null,
};

interface ISignUpDetailsResponse {
  message:string,
}

export const signIn = createAsyncThunk(
  SIGN_IN_USER,
  async ({
    idToken,
    provider,
    isPasswordEnable,
    clientType,
  }: {
    idToken: string | null;
    provider: string;
    isPasswordEnable: boolean;
    clientType: string;
  }, {rejectWithValue}) => {
    try {
      const signUpDetailsResponse = await api.post<ISignUpDetailsResponse>(
        `${signInUrl}`,
        {
          idToken,
          provider,
          isPasswordEnable,
          clientType
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      return signUpDetailsResponse.data;
    } catch (error: any) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({ message: 'Something went wrong' });
    }
  }
);

const signInSlice = createSlice({
  name: SIGN_IN_USER,
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => { 
        state.status = Status.PENDING;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.msg = action.payload?.message ?? null;
      })
      .addCase(signIn.rejected, (state, action:any) => {
        state.status = Status.FAILED;
        state.error = action.payload.message;
      });
  },
});

type Selector = {
  signInApi: ReturnType<typeof signInSlice.reducer>;
};

export const selector = (store: Selector) => store["signInApi"];
export default signInSlice.reducer;
